import { createReducer } from "@reduxjs/toolkit";
import { createAdminStudio, resetCreateAdminStudio } from "./create-admin-studio";
import type { CreationState } from "@redux/state/shared-types";

const initialState: CreationState = {
  processing: "idle",
  justCreatedId: null,
};

export const createAdminStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(createAdminStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(createAdminStudio.fulfilled, (state, action) => {
      state.processing = "success";
      state.justCreatedId = action.payload;
    })
    .addCase(createAdminStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetCreateAdminStudio, () => {
      return initialState;
    });
});
